import { createUseStyles } from 'react-jss';
import colors from "../../../../utils/colors";

var styles = {
  marketingTagsWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap'
  },
  marketingTag: {
    margin: 0,
    fontSize: '1.2rem',
    color: colors.neutral.white,
    padding: '0.4rem 1rem',
    borderRadius: '0.4rem',
    '&:not(:last-child)': {
      marginRight: '1.5rem'
    }
  },
  tag0: { backgroundColor: colors.purple[600] },
  tag1: { backgroundColor: colors.green[600] },
  tag2: { backgroundColor: colors.yellow[600] },
  tag3: { backgroundColor: colors.orange[600] },
  tag4: { backgroundColor: colors.indigo[600] },
  tag5: { backgroundColor: colors.blue[500] }
};

var createStyles = createUseStyles(styles);
export { createStyles };
//# sourceMappingURL=styles.js.map